import { Box, Button, Grid, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom'
import React, { useEffect, useState } from 'react';
import { getAllCategories } from '../../api/api';
import routes from '../../routes/routes';
import { Category } from '../../interfaces/tell_me/category.types';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../store/store';
import { ReelsCategory } from '../../interfaces/tell_me_watch/reelsCategory.types';
function Home() {
    const tellMeCategories = useSelector((state:AppState) => state.categories);
    const tellMeWatchCategories = useSelector((state:AppState) => state.reelsCategories);
    const history = useHistory();

    return (
        <>
            <Grid container style={{ margin: 50 }}>
                <Grid item xs={4}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            history.push(routes.tellMeHomeRouteName)
                        }}>
                        <Typography variant="h5" style={{ fontWeight: "bold" }}>
                            Tell Me
                        </Typography>
                    </Button>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                        TOTAL CATEGORY: {tellMeCategories.length}
                    </Typography>
                    {
                        tellMeCategories.map(e => {
                            return (
                                <Typography id={e.id} style={{ margin: 3 }}>
                                    {e.name} - {e.affirmations.length} Affirmations
                                </Typography>
                            )
                        })
                    }
                </Grid>

            </Grid>
            <Grid container style={{ margin: 50 }}>
                <Grid item xs={4}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            history.push(routes.tellMeWatchRouteName)
                        }}>
                        <Typography variant="h5" style={{ fontWeight: "bold" }}>
                            Tell Me Watch
                        </Typography>



                    </Button>
                </Grid>



                <Grid item xs={8}>
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                        TOTAL CATEGORY: {tellMeWatchCategories.length}
                    </Typography>
                    {
                        tellMeWatchCategories.map((e: ReelsCategory) => {
                            return (
                                <Typography id={e.id} style={{ margin: 3 }}>
                                    {e.name} - {e.reels.length} Reels
                                </Typography>
                            )
                        })
                    }
                </Grid>

            </Grid>
        </>
    );
}

export default Home;